import React from 'react'
import { Tabs, Descriptions, message } from 'antd'
import ActivityList from './components/activityList'
import resourcesApis from './apis'
import apis from '../activity-manage/apis'
import { FormInResourceApply as EditActivityPlan } from '../../components/edit-activity-plan'
import { getQuery, formateTimeStamp } from '@/common/utils'

const { TabPane } = Tabs

export default class System extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      activityPlans: [],
      erps: [],
      resourceData: {},
      num: '1',
      loading: true,
      resourceFirstType: -1,
      resourceName: '',
      startTime: ''

    }
    const url = window.location.href
    this.listRef = { current: {} }
    this.resourceId = getQuery('resourceId', url)
    this.currentPage = 1
    this.pageSize = 10
    this.totalCount = 0
    this.totalPage = 0
    this.loading = true
  }

  componentDidMount () {
    this.handleMyActivityList()
    this.handleGetResource()
  }

  handleGetResource = async () => {
    const option = []
    option.resourceId = this.resourceId
    const resourceData = await resourcesApis.fetchGetResource(option)
    if (resourceData && resourceData.ret && resourceData.ret === '0' && resourceData.data.resource && resourceData.data.resourceState) {
      this.setState({
        resourceData: resourceData.data,
        resourceFirstType: resourceData.data.resourceState.resourceFirstType ? resourceData.data.resourceState.resourceFirstType : -1,
        resourceName: resourceData.data.resource.resourceName,
        startTime: resourceData.data.resource.startTime ? resourceData.data.resource.startTime : ''
      })
    }
  }

  handleMyActivityList = async (currentPage) => {
    this.setState({
      loading: true
    })
    if (currentPage) {
      this.currentPage = currentPage
    }
    const option = []
    option.status = 6
    option.isCreate = 2
    option.currentPage = this.currentPage
    option.pageSize = this.pageSize
    const listData = await apis.fetchMyActivityList(option)
    if (listData && listData.ret && listData.ret === '0' && listData.data.activityPlans) {
      this.totalCount = listData.data.totalCount
      this.totalPage = listData.data.totalPage
      listData.data.activityPlans.map((item, index) => {
        item.key = index + 1
        item.address = '查看详情'
      })
      this.setState({
        loading: false,
        activityPlans: listData.data.activityPlans
      })
    } else {
      message.error(listData.msg)
      this.setState({
        loading: false
      })
    }
  }

  handleCreateSuccess=(res) => {
    this.setState({
      num: '1'
    })
    this.handleMyActivityList()
    this.listRef.current.show(res.data.planCode)
  }

  render =() => {
    return (
      <div style={{ padding: '16px' }}>
        {this.state.resourceData.resource
          ? (
            <Descriptions title='资源位申请' layout='horizontal' column={1}>
              <Descriptions.Item label='申请资源位'>{this.state.resourceData.resource.resourceName}</Descriptions.Item>
              <Descriptions.Item label='资源位生效时间'>{formateTimeStamp(this.state.resourceData.resource.startTime)}</Descriptions.Item>
              <Descriptions.Item label='资源ID'>{this.state.resourceData.resource.resourceId}</Descriptions.Item>
            </Descriptions>) : null}
        <Tabs
          type='card'
          activeKey={this.state.num}
          onChange={(key) => {
            this.setState({
              num: key
            })
          }}
        >
          <TabPane
            tab='选择活动'
            key='1'
          >
            <ActivityList onGetlist={this.handleMyActivityList} data={this.state.activityPlans} resourceName={this.state.resourceName} startTime={this.state.startTime} resourceId={this.resourceId} listRef={this.listRef} currentPage={this.currentPage} totalCount={this.totalCount} totalPage={this.totalPage} loading={this.state.loading} resourceFirstType={this.state.resourceFirstType} />
          </TabPane>
          <TabPane tab='新建活动' key='2'>
            <EditActivityPlan onSuccess={this.handleCreateSuccess} />
            {/* <Peoplemn data={this.state.erps} geterpdata={this.geterpData} /> */}
          </TabPane>

        </Tabs>
      </div>
    )
  }
}
